
            const data = {"name":"glyph/12/triangle-up-white","data":{"width":"12","height":"12","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M13 11 8 5l-5 6z\" class=\"nc-icon-wrapper\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    